import { inject, Injectable, Provider } from '@angular/core';
import { LABEL_RESOLVER, LabelResolver } from '@styleguide/form/label-resolver';
import { BatchedTranslationService } from './batched-translation.service';
import { TranslatableText } from './translatable-text';

@Injectable({
  providedIn: 'root',
})
export class TranslatableLabelResolverService implements LabelResolver {
  private batchedTranslationService = inject(BatchedTranslationService);

  labelsChanged$ = this.batchedTranslationService.translationsLoaded$;

  resolveLabel(value: any): string {
    if (typeof value === 'string') {
      return value;
    }

    if (!this.isTranslatableText(value)) {
      return String(value);
    }

    if (value.translation) {
      return value.translation;
    }

    const cached = this.batchedTranslationService.getCachedTranslation(value.original, value.options);
    if (cached) {
      return cached;
    }

    // Fire-and-forget: trigger async fetch
    this.batchedTranslationService.translate(value, value.options).subscribe();

    return value.original;
  }

  private isTranslatableText(value: any): value is TranslatableText {
    return value != null && typeof value === 'object' && 'original' in value && 'options' in value;
  }
}

export function provideLabelResolver(): Provider {
  return { provide: LABEL_RESOLVER, useExisting: TranslatableLabelResolverService };
}
